import React, { createContext, useContext, useState, useRef } from 'react';
import PropTypes from 'prop-types';

const BreadcrumbContext = createContext({
  breadcrumbs: [],
  setBreadcrumbs: () => {}
});

export function BreadcrumbProvider({ initial = [], children }) {
  const [breadcrumbs, setBreadcrumbs] = useState(initial);
  const initialStr = JSON.stringify(initial);
  const prevStr = useRef(initialStr);

  if (prevStr.current !== initialStr) {
    prevStr.current = initialStr;
    setBreadcrumbs(initial);
  }

  return (
    <BreadcrumbContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumbs() {
  return useContext(BreadcrumbContext);
}

BreadcrumbProvider.propTypes = {
  initial: PropTypes.array,
  children: PropTypes.node
};
